import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { POST_NON_NATIONAL_EXAM_PAYMENT } from "../../constants/apiUrls";
import { useCustomMutation } from '../utils/useCustomMutation';
import {  GenericErrorResponse } from '../typings';


// =============================================================================
// Request & Response Model
// =============================================================================

export interface PostNonNationalExamRegistrationPaymentResponse {
  internalTransactionRef: string;
  transactionAmount: number;
  paymentSuccess: boolean;
}

export interface PostNonNationalExamRegistrationPaymentRequest {
  uuid: string;
  paymentMode: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PostNonNationalExamRegistrationPaymentResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  onSettled?: () => void;
}

export const usePostNonNationalExamRegistrationPayment = ({
  onSuccess,
  onError,
  onSettled,
}: Input) => {
  const postNonNationalExamRegistrationPayment = async (
    payload: PostNonNationalExamRegistrationPaymentRequest
  ) => {
    const res = await axiosClient.post<PostNonNationalExamRegistrationPaymentResponse>(
      POST_NON_NATIONAL_EXAM_PAYMENT,
      payload
    );
    return res.data;
  };

  return useCustomMutation(
    postNonNationalExamRegistrationPayment,
    {
      onSuccess,
      onError,
      onSettled,
    },
  );
};
